import { axios } from "@Root/API";

export const postContactsHesaDetailForm = (contactId, formName, data) => {
  return axios.post(`hesa-detail/${contactId}/save?form_name=${formName}`, data);
};
